import { Component, OnInit } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { SettingsService } from 'src/app/kiosk/services/settings.service';
import { WizardController } from 'src/app/kiosk/services/wizard-controller.service';

@UntilDestroy()
@Component({
  selector: 'kiosk-checkout-complete',
  templateUrl: './checkout-complete.component.html',
})
export class CheckoutCompleteComponent implements OnInit {
  constructor(private readonly wizard: WizardController, private readonly settingService: SettingsService) {}

  ngOnInit(): void {
    this.wizard.notifyCheckoutCompleted(this.settingService.navigationDelay);
  }

  onFinishButtonClicked(): void {
    this.wizard.notifyCheckoutCompleted();
  }
}
